import { ModuleWithProviders, NgModule } from '@angular/core';
import { OrganizationsModule } from '@spaq/modules/organization';
import { ServicesModule } from '@spaq/modules/services';
import { SharedCommonModule, SharedComponentsModule, SharedFormModule, PipesModule } from '@spaq/shared';
import { AccessCodeComponent } from './access-code.component';
import { AccessCodeFormComponent } from './components/access-code-form.component';
import { AccessCodeAddComponent } from './pages/access-code-add.component';
import { AccessCodeListPageComponent } from './pages/access-code-list.component';

@NgModule({
	imports: [
		SharedCommonModule,
		OrganizationsModule,
		PipesModule,
		ServicesModule,
		SharedComponentsModule,
		SharedCommonModule,
		SharedFormModule
	],
	declarations: [AccessCodeListPageComponent, AccessCodeFormComponent, AccessCodeAddComponent, AccessCodeComponent],
	exports: [AccessCodeListPageComponent, AccessCodeFormComponent, AccessCodeAddComponent]
})
export class AccessCodeModule {
	static forRoot(): ModuleWithProviders<AccessCodeModule> {
		return {
			ngModule: AccessCodeModule,
			providers: []
		};
	}
}
